import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import {
  MatDialogRef,
  MatDialog,
  MatDialogConfig,
} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmDialogAnswer } from './confirm-dialog.data';

/**
 * Service class to call confirmation dialog
 */
@Injectable()
export class ConfirmDialogService {
  constructor(private dialog: MatDialog, private translate: TranslateService) {}

  /**
   * Call the confirmation dialog
   * @param text the confirmation dialog text
   * @param reject the rejection button title
   * @param confirm the confirmation button title
   * @param message the confirmation dialog message for confirm option
   * @param isHighlightForConfirm the highlight for confirm button
   */
  public openConfirmDialog(
    text: string,
    reject: string,
    confirm: string = '',
    message: boolean = false,
    isHighlightForConfirm: boolean = true
  ): Observable<ConfirmDialogAnswer> {
    const confirmDialogConfig: MatDialogConfig = {
      panelClass: 'confirm-dialog',
      scrollStrategy: new NoopScrollStrategy(),
    };

    confirmDialogConfig.data = {
      text: text,
      reject: reject,
      confirm: confirm,
      message: message,
      isHighlightForConfirm: isHighlightForConfirm,
    };

    const dialogRef: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(
      ConfirmDialogComponent,
      confirmDialogConfig
    );

    return dialogRef.afterClosed();
  }
}
